import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { IMAGE_MAPPER_BY_TASK_TYPE } from '../../../../helper/imageFileResolver';
import {
  actions as tasksActions,
  selectors as tasksSelectors,
} from '../../../../store/tasks';

const useReorderTasks = () => {
  const reorderTasksIsFetching = useSelector(
    tasksSelectors.selectReorderTasksIsFetching,
  );

  const reorderTasksSuccess = useSelector(
    tasksSelectors.selectReorderTasksSuccess,
  );

  const reorderTasksError = useSelector(tasksSelectors.selectReorderTasksError);

  const taskIsDragging = useSelector(tasksSelectors.selectTaskIsDragging);

  const dispatch = useDispatch();

  const reorderTasksLocally = useCallback(
    (data) => {
      dispatch(tasksActions.reorderTasks(data));
    },
    [dispatch],
  );

  const taskDragStart = useCallback(() => {
    dispatch(tasksActions.taskDragStart());
  }, [dispatch]);

  const reorderTasks = useCallback(
    (tasks) => {
      const tasksData = tasks.map((task) =>
        IMAGE_MAPPER_BY_TASK_TYPE[task.type](task),
      );
      dispatch(tasksActions.reorderTasksRequest(tasksData));
    },
    [dispatch],
  );

  return {
    taskDragStart,
    taskIsDragging,
    reorderTasksLocally,
    reorderTasks,
    reorderTasksIsFetching,
    reorderTasksSuccess,
    reorderTasksError,
  };
};

export default useReorderTasks;
